// UnitCombobox klavye kararı — saf (DOM'suz test): ne yapılacağını söyler, bileşen uygular.

export type ComboKeyAction =
  | { type: "open"; active: number }
  | { type: "move"; delta: 1 | -1 }
  | { type: "pick"; index: number }
  | { type: "commit" } // Enter, listede gezinilmemiş: yazılan metni onayla
  | { type: "close" }
  | { type: "none" };

export interface ComboKeyResult {
  action: ComboKeyAction;
  preventDefault: boolean;
  stopPropagation: boolean;
}

export function comboboxKey(
  key: string,
  ctx: { open: boolean; active: number; selectedIndex: number },
): ComboKeyResult {
  const r = (
    action: ComboKeyAction,
    preventDefault = false,
    stopPropagation = false,
  ): ComboKeyResult => ({ action, preventDefault, stopPropagation });
  if (key === "ArrowDown" || key === "ArrowUp") {
    if (!ctx.open)
      return r({ type: "open", active: ctx.selectedIndex >= 0 ? ctx.selectedIndex : 0 }, true);
    return r({ type: "move", delta: key === "ArrowDown" ? 1 : -1 }, true);
  }
  // Enter her zaman preventDefault: form gönderilmesin
  if (key === "Enter") {
    return ctx.open && ctx.active >= 0
      ? r({ type: "pick", index: ctx.active }, true)
      : r({ type: "commit" }, true);
  }
  // Esc yalnız AÇIK listeyi kapatır ve yayılmaz (KpiModal kapanmasın)
  if (key === "Escape") return ctx.open ? r({ type: "close" }, true, true) : r({ type: "none" });
  if (key === "Tab") return r({ type: "close" });
  return r({ type: "none" });
}
